import type { CameraUpdateMessage } from '@/composables/useConnectSession/setup-channels'
import type { EventDispatcher, Vector2, Vector3 } from 'three'
import type { CameraViewData } from '@/entities/model3d'
import type CameraControls from 'camera-controls'
import type { DeepReadonly } from 'vue'
import type { ModelView } from '~/entities/meeting'

export enum ControlEvent {
  ViewChangedEvent = 'view-changed',
  CameraControlEvent = 'camera-controlled',
  StartTween = 'start-tween',
  StopTween = 'stop-tween',
  SetCameraTweenStart = 'set-camera-tween-start',
  SetCameraTweenComplete = 'set-camera-tween-complete',
}

export interface ControlEventMap {
  [ControlEvent.ViewChangedEvent]: { payload?: any }
  [ControlEvent.CameraControlEvent]: { payload?: any }
  [ControlEvent.StartTween]: { payload?: any }
  [ControlEvent.StopTween]: { payload?: any }
  [ControlEvent.SetCameraTweenStart]: { payload?: any }
  [ControlEvent.SetCameraTweenComplete]: { payload?: any }
}

export const DEFAULT_MODEL_TWEEN_DURATION = 3
export const MODEL_LAYER_TWEEN_DURATION = 0.2
export const MINIMAL_LAYER_TWEEN_DURATION = 0.07

export interface ViewerControls extends EventDispatcher<ControlEventMap> {
  attach(element: HTMLElement): void
  target: [number, number, number]
  cameraControls: CameraControls
  getCenterHitPoint(): Vector3 | null
  setMaxDistance(sceneSize: Vector3): void
  setCameraData(data: Vector2 | CameraViewData | CameraUpdateMessage, optsOrDuration?: SetCameraOptions | number): void
  followControl(message: CameraUpdateMessage): void
  update(delta: number): boolean
  detach(): void
}

export interface SetCameraOptions {
  currentState?: Partial<DeepReadonly<ModelView>>
  tweenDuration?: number | undefined
  disableControls?: boolean | undefined
}
